import { render } from "./Inventory_CustomerTransfersPrint_Dialog.vue?vue&type=template&id=5ebfd10b&scoped=true&ts=true"
import script from "./Inventory_CustomerTransfersPrint_Dialog.vue?vue&type=script&lang=ts"
export * from "./Inventory_CustomerTransfersPrint_Dialog.vue?vue&type=script&lang=ts"

import "./Inventory_CustomerTransfersPrint_Dialog.vue?vue&type=style&index=0&id=5ebfd10b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebfd10b"]])

export default __exports__